import React from "react";
import CNAEsAutomatizadosContainer from "./container";

const CNAEsAutomatizados = (props) => {
  return <CNAEsAutomatizadosContainer {...props} />;
};

export default CNAEsAutomatizados;
